//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum DoorKnockStatus {
	NoAnswer = 200,
	NotInterested = 300,
	GoBack = 400,
	Proposed = 450,
	Sold = 500,
	NeverKnock = 600
}
